/* ==========================================================================
   Bike Finder — modal « Trouvez le vélo idéal »
   Déclenchée par le bouton loupe du hero (.button-search-container .button).
   Pose 2 questions (taille + type de vélo) puis redirige vers /collections/all
   avec les filtres correspondants. Compteur mis à jour dynamiquement via la
   Section Rendering API (section finder-count).
   ========================================================================== */
(function () {
  'use strict';

  // Tranches de taille — identiques à celles du filtre collection (facets.js)
  // La valeur correspond au métafield custom.taille_2 des produits.
  var HEIGHT_RANGES = [
    { min: 0, max: 150, value: '-150cm' },
    { min: 150, max: 160, value: '150cm - 160cm' },
    { min: 160, max: 170, value: '160cm - 170cm' },
    { min: 170, max: 180, value: '170cm - 180cm' },
    { min: 180, max: 190, value: '180cm - 190cm' },
    { min: 190, max: 250, value: '+190cm' }
  ];

  function heightToBracket(cm) {
    if (isNaN(cm)) return null;
    for (var i = 0; i < HEIGHT_RANGES.length; i++) {
      var r = HEIGHT_RANGES[i];
      // dernière tranche inclusive sur le max
      if (cm >= r.min && (cm < r.max || i === HEIGHT_RANGES.length - 1)) {
        return r.value;
      }
    }
    return null;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.getElementById('BikeFinder');
    if (!modal) return;

    var dialog = modal.querySelector('.bike-finder__dialog');
    var heightInput = modal.querySelector('#BikeFinderHeight');
    var chipsWrap = modal.querySelector('#BikeFinderTypes');
    var priceSelect = modal.querySelector('#BikeFinderPrice');
    var submitEl = modal.querySelector('#BikeFinderSubmit');
    var submitText = modal.querySelector('.bike-finder__submit-text');

    var lastFocused = null;
    var debounceTimer;
    var countAbort;

    // ----- Construction de l'URL filtrée -----
    function currentFilters() {
      // La taille ne FILTRE plus la collection : elle est conservée dans le profil
      // (sessionStorage) et sert uniquement à CLASSER les vélos via leur score
      // d'adéquation (voir bike-match.js). On ne filtre que dispo + type + budget.
      var params = ['filter.v.availability=1'];

      // Chaque chip actif porte un/des « filter.p.product_type=... » (multi-select,
      // Shopify combine les product_type en OR).
      var activeChips = chipsWrap.querySelectorAll('.bike-finder__chip.is-active');
      for (var i = 0; i < activeChips.length; i++) {
        params.push(activeChips[i].dataset.filter);
      }

      // Budget (une seule tranche, valeur = un/des « filter.v.price... »)
      if (priceSelect && priceSelect.value) {
        params.push(priceSelect.value);
      }

      return params.join('&');
    }

    function targetUrl() {
      return '/collections/all?' + currentFilters();
    }

    // Parse une valeur de tranche prix (« filter.v.price.gte=1000&...lte=2000 ») en {min,max} en euros
    function parsePrice(v) {
      if (!v) return null;
      var min = null, max = null;
      v.split('&').forEach(function (p) {
        var pair = p.split('=');
        if (pair[0].indexOf('gte') > -1) min = parseFloat(pair[1]);
        if (pair[0].indexOf('lte') > -1) max = parseFloat(pair[1]);
      });
      return { min: min, max: max };
    }

    // Enregistre le profil de recherche pour toute la session (utilisé par bike-match.js)
    function saveProfile() {
      var types = [];
      var activeChips = chipsWrap.querySelectorAll('.bike-finder__chip.is-active');
      for (var i = 0; i < activeChips.length; i++) {
        var dt = activeChips[i].getAttribute('data-types') || '';
        dt.split('|').forEach(function (t) { if (t) types.push(t); });
      }
      var cm = parseInt(heightInput.value, 10);
      var profile = {
        height: isNaN(cm) ? null : cm,
        bracket: heightToBracket(cm),
        types: types,
        price: priceSelect ? parsePrice(priceSelect.value) : null
      };
      try {
        sessionStorage.setItem('loewi_bike_profile', JSON.stringify(profile));
      } catch (e) { /* stockage indisponible : on redirige quand même */ }
    }

    // ----- Compteur dynamique -----
    function setCount(n) {
      var label;
      if (n === 0) {
        label = 'Aucun vélo disponible';
      } else if (n === 1) {
        label = 'Voir notre vélo';
      } else {
        label = 'Voir nos ' + n + ' vélos';
      }
      submitText.textContent = label;
      submitEl.disabled = n === 0;
    }

    function updateCount() {
      var url = targetUrl() + '&section_id=finder-count';
      submitEl.classList.add('is-loading');

      if (countAbort) countAbort.abort();
      countAbort = new AbortController();

      fetch(url, { signal: countAbort.signal })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.getElementById('finder-count-value');
          var n = el ? parseInt(el.textContent.trim(), 10) : NaN;
          if (!isNaN(n)) setCount(n);
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') console.warn('[BikeFinder] count:', err);
        })
        .finally(function () {
          submitEl.classList.remove('is-loading');
        });
    }

    function scheduleCount() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(updateCount, 300);
    }

    // ----- Ouverture / fermeture -----
    function openModal() {
      if (modal.classList.contains('is-open')) return;
      lastFocused = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      updateCount();
      window.requestAnimationFrame(function () {
        heightInput.focus();
      });
    }

    function closeModal() {
      if (!modal.classList.contains('is-open')) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (countAbort) countAbort.abort();
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    // Déclencheur : bouton loupe du hero (desktop + mobile, sur tous les slides)
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.button-search-container .button');
      if (trigger) {
        e.preventDefault();
        openModal();
        return;
      }
      // Fermeture via overlay / croix
      if (e.target.closest('[data-bike-finder-close]')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') {
        closeModal();
        return;
      }
      // Piège de focus simple à l'intérieur de la carte
      if (e.key === 'Tab') {
        var focusables = dialog.querySelectorAll(
          'button, input, select, a[href], [tabindex]:not([tabindex="-1"])'
        );
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    // ----- Interactions champs -----
    heightInput.addEventListener('input', scheduleCount);
    if (priceSelect) priceSelect.addEventListener('change', updateCount);

    // Chips catégories (multi-select : chaque chip se coche indépendamment)
    chipsWrap.addEventListener('click', function (e) {
      var chip = e.target.closest('.bike-finder__chip');
      if (!chip) return;
      var active = chip.classList.toggle('is-active');
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
      updateCount();
    });

    // ----- Validation / redirection -----
    submitEl.addEventListener('click', function () {
      if (submitEl.disabled) return;
      saveProfile();
      window.location.href = targetUrl();
    });
  });
})();
